// extracted by mini-css-extract-plugin
export default {"remarkCard":"Remarks_remarkCard__5MjV2","footerContainer":"Remarks_footerContainer__GlbRw","footer":"Remarks_footer__n4uJh"};